import { getBeforeYouGoTip } from '../../utils/goLocker';
import LocationIcon from '../../images/icon-location-dark.svg';
import GoLockerTip from './GoLockerTip';

import styles from './GoLocker.module.scss';

/**
 * GoLockerBeforeYouGo — Figma "Before you go" (G3 12237:3314 / E3 12258:7216): the
 * lockers-fill-up tip over an outlined "Check Live Availability" button.
 *
 * The button opens the method's `findLocation` (GoLocker's live locker finder) in a
 * new tab. The in-app webview (G4) is out of scope for launch.
 */
const GoLockerBeforeYouGo = ({ bagCount = 1, findLocation }) => (
  <div className={styles.beforeYouGo}>
    <GoLockerTip>{getBeforeYouGoTip(bagCount)}</GoLockerTip>
    {findLocation && (
      <a
        className={styles.outlineButton}
        href={findLocation}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={LocationIcon} alt="" width={20} height={20} />
        <span>Check Live Availability</span>
      </a>
    )}
  </div>
);

export default GoLockerBeforeYouGo;
